import { createGlobalStyle } from "styled-components/macro";

const GlobalStyle = createGlobalStyle`
    html {
      margin: 0;
      padding: 0
    }
    *, *:before, *:after {
      box-sizing: border-box;
    }
    body{
      background: #ffffff;
      padding: 0;
     margin: 0;

      font-size: 16px;
      font-family: 'Helvetica Neue','Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      font-weight: 200;
    }
    a{
      text-decoration: none;
      color: #D2091E;
    }

    h1{
      margin-bottom: 0;
    }

    h1, h2, h3, h4{
      margin-top: 0;
      font-family: Montserrat, sans-serif;
    }
  `;

export default GlobalStyle;
